import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-cell-date-formatter',
  templateUrl: './cell-date-formatter.component.html',
  styleUrls: ['./cell-date-formatter.component.css']
})
export class CellDateFormatterComponent implements OnInit {

  public params: any;


  constructor() {  }

  ngOnInit() {
  }

  agInit(params: any): void {
    this.params = params;
  }

  public moment(data) {
    if (data == null || data === '') {
      return null;
    }
    return moment.utc(data).local().format('DD/MM/YYYY');
  }
}
